/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type WPLResultMessage = {
    readonly id?: number;
    status?: WPLResultMessage.status;
    /**
     * Optional reason for error status
     */
    error_reason?: string | null;
    readonly created_at?: string;
}

export namespace WPLResultMessage {

    export enum status {
        PENDING = 'pending',
        SUCCESS = 'success',
        ERROR = 'error',
        HOLD = 'hold',
        DROPPED = 'dropped',
    }


}
